module.exports = __webpack_public_path__ + "static/media/Hbook-10.966103bb.jpg";